import axios from "@/plugins/Axios";

const model = "frequencies";

function all() {
  return axios.get(`${process.env.VUE_APP_API_URL}/${model}`);
}

function find(id) {
  return axios.get(`${process.env.VUE_APP_API_URL}/${model}/${id}`);
}

function create(frequency) {
  return axios.post(`${process.env.VUE_APP_API_URL}/${model}`, frequency);
}

function update(id, frequency) {
  return axios.put(`${process.env.VUE_APP_API_URL}/${model}/${id}`, frequency);
}

function remove(id) {
  return axios.delete(`${process.env.VUE_APP_API_URL}/${model}/${id}`);
}

export { all, find, create, update, remove };
